// extracted by mini-css-extract-plugin
export var card = "_qd-0";
export var content = "_qd-2";
export var details = "_qd-3";
export var icon = "_qd-1";
export var iconBlue = "_qd-5";
export var iconBrand = "_qd-4";
export var iconGrayBlue = "_qd-6";
export var iconGreen = "_qd-7";
export var iconIndigo = "_qd-8";
export var iconOrange = "_qd-9";
export var iconPurple = "_qd-a";
export var iconRed = "_qd-b";
export var iconWarning = "_qd-c";